// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Button, Dialog, DialogContent, DialogActions, TextField } from '@material-ui/core';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

// Internal Dependencies
import MText from '../../../common/MText';
import apiService from '../../../../services.js/apiService';
import OverLoading from '../../../global/OverLoading';
import Colours from '../../../../styles/colours';
import { IfEmptyThrowError } from '../../../../common/checks';

const AlbumCreateModal = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');

  const handleAddAlbum = async () => {
    try {
      setLoading(true);

      const params = {};

      IfEmptyThrowError(name, 'Name is required');
      params.name = name;

      const album = await apiService.createPageAlbum(props.pageId, params);

      props.onClose();
      history.push(`/admin/page/${props.pageId}/album/${album.id}`);

      toast.success('Album created successfully');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    props.onClose();
    setName('');
  };

  return (
    <>
      {loading && <OverLoading />}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={props.isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div style={{ marginTop: 5 }}>
            <MText bold size="16px" text="Create a new album?" />
          </div>
          <div className="mt-3 mb-2">
            <div className="d-flex align-items-center" style={{ gap: 2 }}>
              <MText text="Name" />
              <MText colour={Colours.Red} text="*" />
            </div>
            <TextField
              fullWidth
              name="name"
              placeholder="Name"
              variant="outlined"
              inputProps={{ style: { fontSize: 13 } }}
              size="small"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <Button color="primary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleAddAlbum} disabled={loading}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

AlbumCreateModal.propTypes = {
  isOpen:  PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  pageId:  PropTypes.string.isRequired,
};

export default AlbumCreateModal;
